<template>
  <div>
    <h3 class="mb-3">
      {{ I18n.t("employees.auctions_catalogs.internet_orders.highest_offer") }}
    </h3>
    <div class="row no-gutters align-items-start mb-5">
      <div class="col-3">
        <p class="text-muted border-bottom mb-2">
          {{ I18n.t("simple_form.labels.order_form.user") }}
        </p>
        {{ auction.lastOrder.user.fullname }}
        <br>
        {{ auction.lastOrder.user.email }}
        <br>
        {{ auction.lastOrder.user.phone }}
      </div>
      <div class="col-3">
        <p class="text-muted border-bottom mb-2">
          {{ I18n.t("employees.auctions_catalogs.date") }}
        </p>
        {{ manageDate({ date: auction.lastOrder.createdAt, format: 'DD.MM.YYYY' }) }}
        <br>
        {{ manageDate({ date: auction.lastOrder.createdAt, format: 'HH.MM' }) }}
      </div>
      <div class="col-3">
        <p class="text-muted border-bottom mb-2">
          {{ I18n.t("employees.auctions_catalogs.order_amount") }}
        </p>
        {{ I18n.t("artworks.price", { price: formatPrice(auction.lastOrder.limit) }) }}
      </div>
      <div class="col-auto ml-auto mt-4 pt-2">
        <EditLastOrder :auction="auction"/>
        <DeleteLastOrder :auction="auction"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { formatNumber } from '@/shared/helpers';
  import ManageDate from '@/shared/mixins/manage_date';
  import EditLastOrder from './edit';
  import DeleteLastOrder from './delete';

  export default {
    name: 'LastOrder',
    components: {
      EditLastOrder,
      DeleteLastOrder,
    },
    mixins: [ManageDate],
    props: {
      auction: {
        type: Object,
      },
    },
    data() {
      return {
        formatPrice: formatNumber,
      };
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees_orders_panel/components/orders/last_order/index.vue?78adda3c